import { INDICATOR_GROUPS, INDICATORS } from "../constants/indicators";

export const flattenIndicators = (query = "") => {
  const q = query.trim().toLowerCase();
  const items = [];

  for (const name of INDICATORS) {
    items.push({ display: name, id: `ind:${name}` });
  }

  if (!q) return items;

  return items.filter((it) => it.display.toLowerCase().includes(q));
};

export const listGroups = (q) =>
  INDICATOR_GROUPS.filter(
    (g) => !q || g.groupName.toLowerCase().includes(q)
  ).map((g) => ({
    display: g.groupName,
    id: `group:${g.groupName}`,
  }));

export const listIndicatorsOf = (groupName, q) => {
  const g = INDICATOR_GROUPS.find((x) => x.groupName === groupName);
  if (!g) return [];
  return g.indicators
    .filter((name) => !q || name.toLowerCase().includes(q))
    .map((name) => ({ display: name, id: `ind:${name}` }));
};
